import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getTopic } from "@store/action/smartend/TopicAction";

const BlogLast = ({ t }) => {
  const store = useSelector((state) => state.NewsReducer);
  const news = store?.data;
  const lang = localStorage.getItem("lang") || "en";
  const lang1 = lang.substring(1, lang.length - 1) || "en";
  const dispatch = useDispatch();
  const webmastertitle = "News";
  useEffect(() => {
    dispatch(
      getTopic(webmastertitle, {
        page: 1,
        per_page: 4,
      })
    );
  }, [dispatch, store?.data?.length]);

  return (
    <div className="blog_wrapper ms_cover">
      <div className="container" style={{ maxWidth: "90%" }}>
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="ms_heading_wrapper">
              <h1>{t("Recent Articles")}</h1>
            </div>
            <div className="relaese_viewall_wrapper">
              <Link to="/dataNews/News/topics">
                {t("view all")} <i className="flaticon-right-arrow" />
              </Link>
            </div>
          </div>
          {news.data?.length &&
            news?.data?.map((item, i) => {
              return (
                <div className="col-lg-6 col-md-12 col-sm-12" key={i}>
                  <div className="featured_artist_list blog_img_content ms_cover">
                    <img
                      src={item.photo_file && item.photo_file}
                      className="img-responsive"
                      alt="img"
                    />
                    <div className="featured_artist_detail blog_content_box">
                      <span>
                        <i className="flaticon-calendar" />
                        {new Date(item.date).toLocaleString(`${lang1}-US`, {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })}
                      </span>
                      <p>
                        <Link to={`/dataNews/News/topics/${item.id}`}>
                          {item.title}
                        </Link>
                      </p>
                      <Link to={`/dataNews/News/topics/${item.id}`}>
                        {t("read more")}
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default BlogLast;
